namespace Areas.Project.View {
    "use strict";

    var tabItems = Areas.createTabsWithSameAction("Project", "View",
        ["Profile", "Building", "Drawing", "Permit", "AutoCad", "Picture", "Presentation", 
            "OtherAttachment", "AllAttachment"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }
}